import { createContext, useContext } from 'react';
export const FormContext = createContext(undefined);
export function useForm() {
    const context = useContext(FormContext);
    if (context === undefined) {
        throw new Error('useForm must be used within a FormProvider');
    }
    return context;
}
export function useNestedFormByTarget(target) {
    const form = useForm();
    if (!form.nestedForms?.length) {
        return;
    }
    return form.nestedForms?.find((nestedForm)=>nestedForm.targets?.includes(target))?.form;
}

//# sourceMappingURL=form-context.js.map